var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ED1C24;}\n\t.st1{fill:#009245;}\n\t.st2{fill:#F0F0F0;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Italy (2)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Italy"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15,0C6.7,0,0,6.7,0,15s6.7,15,15,15V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15,0c-1.7,0-3.4,0.3-5,0.9v28.3c3.2,1.2,6.8,1.2,10,0V0.9C18.4,0.3,16.7,0,15,0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly);
export default __webpack_public_path__ + "static/media/italy.2329592c33300e87d1cd9a2de69ec6b0.svg";
export { ForwardRef as ReactComponent };